module.exports = __webpack_public_path__ + "static/icon-6-5a09fd96af06fcbcadc7047a02d3243f.png";